import { render, staticRenderFns } from "./protocol_detail.vue?vue&type=template&id=2822379e&scoped=true&"
import script from "./protocol_detail.vue?vue&type=script&lang=js&"
export * from "./protocol_detail.vue?vue&type=script&lang=js&"
import style0 from "./protocol_detail.vue?vue&type=style&index=0&id=2822379e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2822379e",
  null
  
)

export default component.exports